<template>
  <div class="puzzleContainer">
    <div class="w-full h-0">
      <img src="../assets/icons/spacecraftIcon.svg" alt="Kaffea Terra spacecraft"
           class="w-[10vw] relative left-[10%]">
    </div>
    <div class="title" v-if="!isSolved">
      <p> {{ $t('puzzlePage.firstPartTitle') }}</p>
      <p> {{ $t('puzzlePage.SeqPartTitle') }}</p>
    </div>
    <div class="puzzle-grid" v-if="!isSolved">
      <div
          v-for="(piece, index) in shuffledPieces"
          :key="index"
          class="puzzle-piece"
          :style="{
                backgroundImage: `url(${imageUrl})`,
                backgroundPosition: piece.position,
                backgroundSize: `${gridSize * 100}% ${gridSize * 100}%`,
                border: selectedPiece === index ? '5px double #0090d4' : '1px solid #ddd',
              }"
          @click="onPieceClick(index)"
      ></div>
    </div>

    <div v-if="isSolved" class="title">
      <p class="wowTitle">WOW!</p>
      <p> {{ $t('puzzlePage.result') }}</p>
    </div>
    <div v-if="isSolved" class="relative ">
      <img src="../assets/celebrationLeft.svg" alt="left-celebrate"
           class="celebrate-icon-left absolute h-[80%]">
      <img src="../assets/celebrationRight.svg" alt="right-celebrate"
           class="celebrate-icon-right absolute h-[80%]">
      <img :src="imageUrl" :alt="answers.question2.country" class="puzzle-result">
    </div>
  </div>

  <div class="flex justify-end gap-[1vw] absolute bottom-0 w-full">
    <div @click="goToPreviousStep">
      <img src="@/assets/arrowleft.svg" alt="arrow-left" class="w-[5vw] h-[5vw]">
    </div>
    <div @click="goToNextStep">
      <img src="@/assets/arrowright.svg" alt="arrow-right" class="w-[5vw] h-[5vw]">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    answers: Object,
  },
  data() {
    const gridSize = 3;
    const imageUrls = {
      Brazil: "/coffees/Brazil.png",
      Colombia: "/coffees/Colombia.png",
      Ethiopia: "/coffees/Ethiopia.png",
      Kenya: "/coffees/Kenya.png",
      India: "/coffees/India.png",
      PapuaNewGuinea: "/coffees/PapuaNewGuinea.png",
    };

    const pieces = Array.from({length: gridSize * gridSize}, (_, i) => {
      const row = Math.floor(i / gridSize);
      const col = i % gridSize;
      return {
        id: i,
        position: `${-col * 100}% ${-row * 100}%`,
      };
    });

    const imageUrl = imageUrls[this.answers.question2.country];

    return {
      gridSize,
      imageUrl,
      pieces,
      shuffledPieces: [...pieces].sort(() => Math.random() - 0.5),
      selectedPiece: null,
      isSolved: false,
    };
  },
  methods: {
    onPieceClick(index) {
      if (this.selectedPiece === null) {
        this.selectedPiece = index;
      } else {
        const temp = this.shuffledPieces[index];
        this.shuffledPieces[index] = this.shuffledPieces[this.selectedPiece];
        this.shuffledPieces[this.selectedPiece] = temp;
        this.selectedPiece = null; // Reset selection
      }
    },
    goToPreviousStep() {
      this.$emit('prev-step');
    },
    goToNextStep() {
      if (this.isSolved) {
        this.$emit('next-step');
      }
    },
  },
  watch: {
    shuffledPieces: {
      handler() {
        this.isSolved = this.shuffledPieces.every((piece, index) => piece.id === index);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.puzzleContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 60px;
  overflow: hidden;
  padding-bottom: 10%;

  @media only screen and (max-width: 1000px) {
    gap: 30px;
  }
  @media only screen and (max-width: 750px) {
    gap: 15px;
  }
}

.title {
  text-align: center;
  font-size: 7vw;
  line-height: normal;
  color: #FFFFFF;
  text-transform: uppercase;
  padding-top: 40px;
}

.wowTitle {
  font-size: 8vw;
  line-height: normal;
}

.puzzle-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  justify-content: center;
  align-items: center;
}

.puzzle-piece {
  width: 24vw;
  height: 24vw;
  border: 1px solid #ddd;
  background-color: #ccc;
  cursor: pointer;
  touch-action: manipulation;
  box-sizing: border-box;
}

.puzzle-result {
  width: 75vw;
  height: 75vw;
  outline: 8px solid #FFFFFF;
  border: 8px solid #555E8E;
  background-color: #ccc;
  cursor: pointer;
  touch-action: manipulation;
  box-sizing: border-box;
}

.celebrate-icon-right {
  right: -15%;
}

.celebrate-icon-left {
  left: -15%;
}

.celebrate-icon-right, .celebrate-icon-left {
  top: 15%;
  animation: inToOut 0.5s ease-out;
}

@keyframes inToOut {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

</style>
